import {LowestPriorPrice} from '@aboutyou/backbone/types/BapiProduct';
import {
  Currency,
  formatPrice,
} from '@aboutyou/legacy-shared/src/utils/currency';
import i18next from 'i18next';
import {exists} from '../../utils/exists';

type TranslateFnType = i18next.TFunction;

export const getLowestPriorPrice = (
  t: TranslateFnType,
  currencyCode: string,
  currency: Currency,
  lowestPriorPrice?: LowestPriorPrice,
): string | undefined => {
  if (
    !lowestPriorPrice ||
    !exists(lowestPriorPrice.relativeDifferenceToPrice) ||
    !exists(lowestPriorPrice.withTax)
  ) {
    return;
  }

  const lpl30d = formatPrice(lowestPriorPrice.withTax, currencyCode, currency);

  const relativeDifferenceToPrice = (() => {
    const relativeDiff = lowestPriorPrice.relativeDifferenceToPrice;

    if (relativeDiff === 0) {
      return 0;
    }

    const sign = relativeDiff > 0 ? '+' : '';

    return `${sign}${Math.round(relativeDiff * 100)}`;
  })();

  return `${t('30-Tage-Bestpreis')}: ${lpl30d} (${relativeDifferenceToPrice}%)`;
};
